import BaseModal from "./BaseModal";
import s from './BaseModal.module.css';
import l from './LoginModal.module.css';
import LoadingLogo from "components/Logos/LoadingLogo";

const ExportModal = ({onClose, exportLoading, exportError, exportSuccess}) => {
    
    return ( 
        <BaseModal height="20rem" onClose={onClose}>
            <div className={l.loginModalContainer}>
            {exportLoading && (
                <>
                    <LoadingLogo />
                </>
            )}
            {exportSuccess && (
                <>
                    <div className={l.title}>
                        Export Successful
                    </div>
                    <div className={l.subtitle}>
                        Your contacts have been successfully exported as a CSV file!
                    </div>
                    <div 
                        className={`${s.blackButton} ${l.button}`}
                        onClick={onClose}
                    >
                        OK
                    </div>
                </>
            )}
            {exportError && (
                <>
                    <div className={l.title}>
                        Error Exporting Contacts
                    </div>
                    <div className={l.subtitle}>
                        Please refresh the page and try again!
                    </div>
                </>
            )}
            </div>
        </BaseModal>
     );
}
 
export default ExportModal;